// extracted by mini-css-extract-plugin
module.exports = {"label":"Selector_label__2eZA9","select":"Selector_select__131YQ"};